import frFR from './fr-FR.json';

export default {
  'fr-FR': frFR,
};
